export const getEvent = (state) => state.event.toJS().data;

export const getShowEventMessagingBanner = (state) =>
  state.event.toJS().showEventMessagingBanner;
